<div class="container scroll_services">
  <section class="inner-container">
    <main>
      <div class="products">
        <div class="content-container" [hidden]="this.servicesAdded.length > 0 || this.submitted.length > 0">
          <div class="text-center">
            <h1 class="title-default">Choose your business to get started:</h1>
          </div>
          <section class="pricing-plane-area section_padding_100_70 clearfix" id="products">
        <div class="container">
            
          <div class="col-md-12 no-gutters">
            <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- Package Price  -->
                <div class="single-price-plan text-center">
                    <!-- Package Text  -->
                    <div class="package-plan">
                    <div class="client-thumbnail">
                        <img src="images/bg-img/icons-02.png" alt="">
                    </div>
                    <div class="ca-price d-flex justify-content-center">
                      <h5><strong>Online Store</strong></h5>
                    </div>
                    <p style="height: 100px;">You run an online business and you need to accept instant online payment.</p>
                    </div>
                    <!-- Plan Button  -->
                    <div class="plan-button">
                        <a href="javascript:void(0)" (click)="addServices(eServices); bundleName='Online Store'" >Apply Now</a>
                    </div>
                    <div class="package-description">
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['Online Banking']?.desc">Online Banking&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['Cards Payment Gateway']?.desc">Cards Payment Gateway&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      
                    </div>
                    
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- Package Price  -->
                <div class="single-price-plan text-center">
                    <!-- Package Text  -->
                  <div class="package-plan">
                   <div class="client-thumbnail">
                     <img src="images/bg-img/icons-01.png" alt="">
                    </div>
                        <div class="ca-price d-flex justify-content-center">
                          <h5><strong>Retail</strong></h5>
                        </div>
                    <p style="height: 100px;">You have a physical presence and you need to accept payment in-store.</p>
                  </div>
                  <!-- Plan Button  -->
                    <div class="plan-button">
                        <a href="javascript:void(0)" (click)="addServices(bmServices); bundleName='Retail'" >Apply Now</a>
                    </div>
                  <div class="package-description">
                    <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['POS Terminal']?.desc">POS Terminal&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                    <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['mPOS']?.desc">mPOS&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                    
                     <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['QRPayBiz']?.desc">QRPayBiz&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                  </div>

                    
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- Package Price  -->
                <div class="single-price-plan text-center">
                    <!-- Package Text  -->
                  <div class="package-plan">
                    <div class="client-thumbnail">
                        <img src="images/bg-img/icons-03.png" alt="">
                    </div>
                    <div class="ca-price d-flex justify-content-center">
                      <h5><strong>Online Store + Retail</strong></h5>
                    </div>
                    <p style="height: 100px;">You have both pysical and online business presence and you need to accept payment in-store and online.</p>
                  </div>
                  <!-- Plan Button  -->
                    <div class="plan-button">
                      <a href="javascript:void(0)" (click)="addServices(bmServices); addServices(eServices); bundleName='Online Store + Retail'">Apply Now</a>
                    </div>
                  <div class="package-description">
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['Online Banking']?.desc">Online Banking&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['Cards Payment Gateway']?.desc">Cards Payment Gateway&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['POS Terminal']?.desc">POS Terminal&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['mPOS']?.desc">mPOS&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                      
                       <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['QRPayBiz']?.desc">QRPayBiz&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                  </div>
                    
                </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
                <!-- Package Price  -->
                <div class="single-price-plan text-center">
                    <!-- Package Text  -->
                    <div class="package-plan">
                    <div class="client-thumbnail">
                        <img src="images/bg-img/icons-04.png" alt="">
                    </div>
                    <div class="ca-price d-flex justify-content-center">
                      <h5><strong>Others</strong></h5>
                    </div>
                    <p style="height: 100px;">You need other payment services like JomPAY.</p>
                    </div>
                    <!-- Plan Button  -->
                    <div class="plan-button">
                        <a href="javascript:void(0)" (click)="addServices(oServices); bundleName='Others'" >Apply Now</a>
                    </div>
                    <div class="package-description">
                     <!--  <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['FPX']?.desc">FPX&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
 -->
                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['JomPAY']?.desc">JomPAY&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>

                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['AutoDebit']?.desc">AutoDebit&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>

                      <p><span class="top" [attr.data-tooltip]="SERVICE_DESC['Maybank2u Biller']?.desc">Maybank2u Biller&nbsp;<i class="ti-info-alt" aria-hidden="true"></i></span></p>
                    </div>
                    
                </div>
            </div>
        </div>


          
        </div>
    </section>

          
          
        </div>
        <div class="content-container" *ngIf="servicesAdded.length > 0 || submitted.length > 0">
          <div class="service-choice-inner">
            <div class="row col-md-10 col-md-offset-1" >
            <h1 class="title-default" *ngIf="bundleName">You have selected the {{bundleName}} bundle. <br/>Below are the service(s) pre-selected for you:</h1>


            
            <h1 class="title-default" *ngIf="bundleName == null">Choose your preferred service</h1>

            <div class="row">
              <div class="col-md-4">
                <p>You can choose more than one solution</p>
              </div>
              <div *ngIf="submitted.length<1" class="col-md-6">
              </div>
              <div *ngIf="submitted.length>0" class="col-md-5">
              </div>
              <div *ngIf="submitted.length<1" class="col-md-2 align-right legend">
              
              
                  <p>&nbsp;Legend: &nbsp;</p><div id="circle-yellow"></div>
                  <p>&nbsp;Selected &nbsp; &nbsp;&nbsp;</p>
                
                          
              </div>
              <div *ngIf="submitted.length>0"  class="col-md-3 align-right legend" style="display: -webkit-inline-box;">
                
                
                  <p>&nbsp;Legend: &nbsp;</p><div id="circle-yellow"></div>
                  <p>&nbsp;Selected &nbsp; &nbsp;&nbsp;</p>
                  <div id="circle-grey"></div> 
                  <p>&nbsp;Applied</p>
                
                          
              </div>
            </div>
            </div>
          </div>
          
          <div class="inner" >
            <div class="row box-default box-primary col-md-10 col-md-offset-1" >
              <div *ngFor="let service of services" class="col-md-3 service-choice-button">
                <div class="service-choice" [attr.data-tooltip]="SERVICE_DESC[service.name]?.desc" >
                  <button  (click)="add(service)" [ngClass]="{'clicked': added(service), 'submitted': isSubmitted(service)}" class="col-md-2 btn btn-default btn-block" style="text-transform: none"> 
                    {{service.name}}<i class="ti-info-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row col-md-10 col-md-offset-1">
              <div class="col-xs-2">
                <button *ngIf="submitted.length > 0" routerLink="/dashboard" class="btn btn-primary">Dashboard</button>
              </div>
              <div class="col-xs-8">
              </div>
              <div class="col-md-2 align-right">
                <button (click)="confirm()" href="/form" class="btn btn-primary">CONFIRM</button>
              </div>
            </div>


            
          </div>

          <div class="inner">
            <div class="row col-md-10 col-md-offset-1" >
              <div class="row">
                <div class="col-md-6">
                  <h5 class="title-form mrgn-btm-1rem">Document to Prepare</h5>
                  <div class="row">
                    <div class="col-xs-3">
                      <img class="" src="images/doc.png" />
                    </div>
                    <div class="col-xs-9">
                      <div class="row">
                        <p class="">You can prepare the documents upfront before applying.</p><br/>
                        <a class="" target="_blank" href="assets/DocumentsRequired.pdf">> Click to view require documents</a>
                      </div>
                    </div>
                    
                  </div>
                    
                </div>
                <div class="col-md-6">
                  <h5 class="title-form mrgn-btm-1rem">Frequent Ask Question</h5>
                  <div class="row">
                    <div class="col-xs-3">
                      <img class="" src="images/faq.png" />
                    </div>
                    <div class="col-xs-9">
                      <div class="row">
                        <p class="">Browse through the FAQs to find answers to commonly raised questions</p><br/>
                        <a class="" target="_blank" href="assets/faq/index.html">> Click to read more</a>
                      </div>
                    </div>
                    
                  </div>

                    
                </div>

                <div class="col-md-6">
                  
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</div>
